import { render, staticRenderFns } from "./DetailRawMenu.vue?vue&type=template&id=b837ba34"
import script from "./DetailRawMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailRawMenu.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports